<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Halftitle">
<p class="half"><span class="right_1" epub:type="pagebreak" id="page_xi" title="xi"><span class="small">FROM</span> STREET <span class="small">TO</span> SCREEN<span class="right_1" epub:type="pagebreak" id="page_xii" title="xii"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253049537_Halftitle1.vue?6215807e